<template>
  <div style="width: 600px;margin: 30px auto 0;">
    <el-form ref="form" :rules="rules" :model="form" label-width="160px">
      <el-form-item label="手机号码" required>
        <!-- <el-input
          v-model="form.phone"
          placeholder="请输入手机号码"
          maxlength="11"
          @input="handlePhoneInput"
        /> -->
        <div>{{ phoneNum }}</div>
      </el-form-item>
      <el-form-item label="验证码" prop="verifyCode" required>
        <div style="display: flex;">
          <el-input
            v-model="form.verifyCode"
            placeholder="请输入验证码"
            style="width: 200px;"
            maxlength="6"
          />
          <!-- !form.phone || !isPhoneValid || -->
          <el-button
            type="primary"
            :disabled="countdown > 0"
            style="margin-left: 10px;"
            @click="getVerifyCode"
          >
            {{ countdown > 0 ? `${countdown}秒后重试` : "获取验证码" }}
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="新支付密码" prop="payPwd" required>
        <el-input
          v-model="form.payPwd"
          show-password
          placeholder="请输入6位数字"
          maxlength="6"
          @input="handlePwdInput($event, 'payPwd')"
        />
      </el-form-item>
      <el-form-item label="确认支付密码" prop="confirmPwd" required>
        <el-input
          v-model="form.confirmPwd"
          show-password
          placeholder="请确认支付密码"
          maxlength="6"
          @input="handlePwdInput($event, 'confirmPwd')"
        />
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button type="primary" @click="handleSubmit">立即提交</el-button>
      <el-button @click="resetForm('form')">重置</el-button>
    </div>
  </div>
</template>

<script>
import { updatePSW, sendVerificationCode, editPSW } from "@/api/pay.js";
import { Base64 } from "js-base64";
export default {
  name: "EditPassword",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入验证码"));
      } else if (!/^\d{6}$/.test(value)) {
        callback(new Error("请输入6位数字验证码"));
      } else {
        callback();
      }
    };
    const validatePayPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入支付密码"));
      } else if (!/^\d{6}$/.test(value)) {
        callback(new Error("请输入6位数字"));
      } else {
        callback();
      }
    };
    const validateConfirmPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请确认支付密码"));
      } else if (value !== this.form.payPwd) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    return {
      form: {
        // phone: "",
        verifyCode: "",
        payPwd: "",
        confirmPwd: ""
      },
      rules: {
        // phone: [{ validator: validatePhone, trigger: "blur" }],
        verifyCode: [{ validator: validateVerifyCode, trigger: "blur" }],
        payPwd: [{ validator: validatePayPwd, trigger: "blur" }],
        confirmPwd: [{ validator: validateConfirmPwd, trigger: "blur" }]
      },
      countdown: 0,
      timer: null,
      isPhoneValid: false
    };
  },
  computed: {
    phoneNum() {
      let party = this.$store.getters.party;
      return party.phone;
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    handlePhoneInput(value) {
      // this.form.phone = value.replace(/\D/g, "");
      // this.isPhoneValid = /^1[3-9]\d{9}$/.test(this.form.phone);
    },
    handlePwdInput(value, field) {
      this.form[field] = value.replace(/\D/g, "");
    },
    async getVerifyCode() {
      // this.$refs.form.validateField("phone", async valid => {
      //   if (!valid) {
      try {
        let res = await sendVerificationCode({
          phone: this.phoneNum, // this.form.phone,
          partyGroupCode: this.$store.state.user.party.branchCode
        });
        console.log("发送验证码=======", res);
        this.countdown = 60;
        this.timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      } catch (error) {
        console.error("获取验证码失败:", error);
        this.$message.error("获取验证码失败，请稍后重试");
      }
      //   }
      // });
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await editPSW({
              verifyCode: this.form.verifyCode,
              payPassword: Base64.encode(this.form.payPwd)
            });
            this.resetForm("form");
            this.$message.success("支付密码修改成功");
          } catch (error) {
            console.error("修改支付密码失败:", error);
            this.$message.error("修改支付密码失败，请稍后重试");
          }
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.countdown = 0;
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: center;
  margin-top: 20px;
}
</style>
